import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-bootstrap'
import { hotspotterQuery } from '../redux/dataAnalyticsActions'


class Hotspotter extends Component {
    constructor(p) {
        super(p)

        this.state = { searching: false, input: { text: '', minPosition: 0.1 }, result: null }
    }

    updateSearch = (e) => {
        this.setState({ input: { ...this.state.input, [e.target.name]: e.target.value } })
    }

    submit = () => {
        this.toggleSearching()
        hotspotterQuery(this.state.input.text, this.state.input.minPosition).then(t => {
            console.log(t.data.mapReduceResult)
            this.toggleSearching()
            this.setState({ result: t.data.mapReduceResult, recordsLength: t.data.recordsLength })
        }).catch(e => {
            this.toggleSearching()
        })
    }

    toggleSearching = () => {
        this.setState({ searching: !this.state.searching })
    }

    generateResult = () => {
        if (!this.state.result) return <Col xs={12} md={12} lg={12}> <p>Ingen sökning gjord</p></Col>


        return this.state.result.map(pair => {
            const value = pair[0]
            const score = pair[1]

            return (
                <Col key={value} xs={12} md={3} lg={3} style={{ backgroundColor: 'white', padding: 5, marginBottom: 3, marginLeft: 3, border: '1px solid lightgrey' }}>
                    <p style={{ color: 'green' }}>{score}</p>
                    <p className="HotspotterLink" onClick={() => this.props.hotspotterSearch(value)}>{value}</p>
                </Col>
            )
        })
    }

    render() {
        return (
            <Grid fluid>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <h3>Hotspotter</h3>
                        <p>Hotspotter söker igenom de senaste ~80.000 filerna vi fått och rankar dessa signaler baserat på hur ofta ett ord har förekommit i dem. Sök på "JM" -> Du får top-rankade signaler som även innehåller JM.</p>

                    </Col>
                </Row>

                <hr />

                <Row>
                    <Col xs={12} md={4} lg={4}>
                        <div
                            style={{ borderRadius: 10, height: 42, fontSize: 14, cursor: "default" }}
                            className="delivery-filter-container">
                            <select onChange={this.updateSearch} name="minPosition" className="Sök">
                                {/* <option selected>Filterat toppresultat</option> */}
                                {[0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1].map(val => {
                                    return <option key={val} value={val}>{`${val * 100}%`}</option>
                                })}
                            </select>
                        </div>
                    </Col>

                    <Col xs={12} md={4} lg={4}>
                        <div
                            style={{ borderRadius: 10, height: 42, fontSize: 14, cursor: "default" }}
                            className="delivery-filter-container">
                            <input
                                type="text"
                                onChange={this.updateSearch}
                                name="text"
                                placeholder="Fritext"
                                className="Sök"
                                onKeyDown={(e) => { if (e.keyCode === 13) this.submit() }}
                            />
                        </div>
                    </Col>

                    <Col xs={12} md={4} lg={4}>
                        {this.state.searching ?
                            <div className="smallQbutton" style={{ width: '100%', backgroundColor: 'lightgrey' }}>
                                Söker
                        </div> :
                            <div className="smallQbutton" style={{ width: '100%' }} onClick={this.submit}>
                                Sök
                        </div>
                        }
                    </Col>
                </Row>

                <hr />


                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {this.state.recordsLength ? <b>{`${this.state.recordsLength}st signaler genomsökta`}</b> : null}
                    </Col>
                </Row>
                <Row>
                    {this.generateResult()}
                </Row>
            </Grid>
        )
    }

}

export default Hotspotter